module.exports = __webpack_public_path__ + "static/media/logo.31d88b03.svg";